import React from 'react';
import PropTypes from 'prop-types';

const MainContent = props => {
  const { children, sidebar, isWidget } = props;

  const mainDivClasses = isWidget ? 'col-12' : !sidebar ? 'col-12 col-md-10 mx-auto' : 'col-12 col-md-9';
  return (
    <section>
      <div className="container pb-4">
        <main>
          <div className="row">
            <div className={mainDivClasses}>{children}</div>
            {sidebar}
          </div>
        </main>
      </div>
    </section>
  );
};

MainContent.propTypes = {
  // opcional: a HomePage (página de busca) não tem sidebar
  sidebar: PropTypes.element,
};

MainContent.defaultProps = {
  sidebar: null,
};

export default MainContent;
